function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { worldViewerWindow } from '../const';
import { getSkywayOnTellScreenShareStart, getSkywayOnTellWaitScreenShare } from '../logics/dataOps';
import { GetIHeliNetwork } from './heliodor_networklib';
export class CCrpRegist {
    // crpFrontを渡す
    initialize(crpFront) {
        const iHeliNetwork = GetIHeliNetwork();
        const iHeliNetworkCallback = iHeliNetwork === null || iHeliNetwork === void 0 ? void 0 : iHeliNetwork.getCallback();
        crpFront.onOpened(()=>{
            console.log('onOpened');
            crpFront.sendMovement([
                0,
                0,
                0
            ], [
                0,
                0,
                0,
                0
            ], [
                0,
                0,
                0
            ], 1, 0);
        });
        crpFront.onEntered(({ objectId  })=>{
            console.log('crpFront.onEntered objectId', objectId);
            worldViewerWindow.hel_skyway_receive_data('open', objectId, '');
            iHeliNetwork === null || iHeliNetwork === void 0 ? void 0 : iHeliNetwork.sendData('start');
            // PlayerIDが使用可能になったことを通知する
            iHeliNetworkCallback === null || iHeliNetworkCallback === void 0 ? void 0 : iHeliNetworkCallback.OnNetCreatedPlayerID(objectId);
            iHeliNetworkCallback === null || iHeliNetworkCallback === void 0 ? void 0 : iHeliNetworkCallback.OnNetPosConnected();
            console.log('CRPFRONT: 座標チャンネル接続完了');
            iHeliNetwork === null || iHeliNetwork === void 0 ? void 0 : iHeliNetwork.afterJoinPosRtc();
        });
        crpFront.onRemoteLeave((context)=>{
            const { objectId , user  } = context;
            if (user.userRole === 'presenter' && this.m_presenterIdList.includes(objectId)) {
                this.m_presenterIdList.splice(this.m_presenterIdList.indexOf(objectId), 1);
                if (this.m_presenterIdList.length === 0) {
                // leave
                }
            }
        });
        // 他プレーヤー入室時
        crpFront.onRemoteJoin((info)=>{
            console.log('onRemoteJoin', info);
            const objectId = info.objectId;
            const role = info.role;
            const name = info.name;
            const avatarId = info.avatarId;
            const isStart = info.isStart;
            const user = info.user;
            iHeliNetwork.createPlayer(objectId, user.userCode, user.channelSessionCode, role, user.rtcUserCode);
            const startFlag = isStart ? '1' : '0';
            const sanitizedAvatarId = this.sanitizeAvatarId(role, avatarId);
            worldViewerWindow.hel_skyway_receive_data('data', objectId, `join:${name}:${sanitizedAvatarId}:${startFlag}`);
            if (role === 'presenter') {
                console.log('onRemoteJoin presenter');
                iHeliNetwork === null || iHeliNetwork === void 0 ? void 0 : iHeliNetwork.sendHighFrequentSyncSubscribe(objectId, true);
                window.setTimeout(()=>{
                    worldViewerWindow.hel_player_SetPriority(objectId, -1);
                }, 1000);
            }
        });
        // onReceiveData は 非推奨。onRemoteDataに一元化
        crpFront.onReceiveData(({ objectId , data , role  })=>{
        // CRPからobjectId空のデータでjoinを受け取ったら無視
        /*
        if (objectId === undefined && data.startsWith('join:')) {
          console.warn('crpFront undefined objectId join received');
          return;
        }
        if (data.startsWith('screenshare:')) {
          this.handleMessageScreenShare(iHeliNetwork, objectId, data, role);
        }
        worldViewerWindow.hel_skyway_receive_data('data', objectId, data)
        */ });
        crpFront.onRemoteCustomState(({ objectId , value , user  })=>{
            console.log('change custome state', objectId, user, value);
        });
        crpFront.onRemoteData(({ action , objectId , data , user  })=>{
            // console.log("remote data.", {action, objectId, data})
            // CRPからユーザーnullのメッセージを受け取ったら無視
            if (user === undefined) {
                console.warn('crpFront undefined user message');
                return;
            }
            if (data.startsWith('screenshare:')) {
                this.handleMessageScreenShare(iHeliNetwork, objectId, data, user.userRole);
            }
            worldViewerWindow.hel_skyway_receive_data(action, objectId, data);
        });
        crpFront.onClosed(({ ev  })=>{
            console.log(ev);
        });
        crpFront.onError(({ requestId , code , message  })=>{
            console.error(`request id: ${requestId}, code: ${code}, message: [${message}]`);
            let time = 3000;
            switch(code){
                case 'RTC03010201':
                case 'RTC03010104':
                    switch(this.m_ReOpenCount){
                        case 1:
                            time = 5000;
                            break;
                        case 2:
                            time = 10000;
                            break;
                        case 3:
                            time = 30000;
                            break;
                        case 4:
                            iHeliNetworkCallback === null || iHeliNetworkCallback === void 0 ? void 0 : iHeliNetworkCallback.OnNetConnectionError(code);
                            return;
                        default:
                            time = 3000;
                    }
                    // 接続エラー
                    // n秒後に再接続
                    setTimeout(async ()=>{
                        const channelSessionJwt = (await worldViewerWindow.heliport.v3.api.channelSessionApi.getChannelSessionJwt()).data;
                        if (channelSessionJwt !== null) {
                            await crpFront.close();
                            await crpFront.open(channelSessionJwt);
                        }
                        this.m_ReOpenCount++;
                    }, time);
                    break;
                default:
                    return;
            }
        });
    }
    handleMessageScreenShare(iHeliNetwork, playerId, data, role) {
        if (data === 'screenshare:tell') {
            const fn = getSkywayOnTellScreenShareStart();
            if (fn !== undefined) {
                fn();
                return;
            }
        }
        if (data === 'screenshare:waitstart') {
            const fn = getSkywayOnTellWaitScreenShare();
            if (fn !== undefined) {
                fn();
                return;
            }
        }
        const paramsScreenShare = data.split(':');
        if (paramsScreenShare[1] === 'start') {
            const player = iHeliNetwork.getPlayer(playerId);
            if (player === null) {
                return;
            }
            // @ts-ignore
            player.setVideoItemName(paramsScreenShare[2]);
            // @ts-ignore
            player.setVideoMaterialName(paramsScreenShare[3]);
        }
        if (paramsScreenShare[1] === 'stop') {
            // グローバルにhel_onReceiveNoticeScreenShareStopが定義されていた場合に実行する
            if (typeof worldViewerWindow.hel_onReceiveNoticeScreenShareStop === 'function') {
                worldViewerWindow.hel_onReceiveNoticeScreenShareStop(playerId);
            } else {
                worldViewerWindow.hel_video_stop();
                worldViewerWindow.hel_video_close_genericwindow();
                // HeliScriptのコールバックを呼び出す
                worldViewerWindow.hel_setText(worldViewerWindow.ETextParamType_OnReceivedStopScreenShare, '');
            }
        }
    }
    // コンストラクタ
    constructor(){
        _defineProperty(this, "m_presenterIdList", []);
        _defineProperty(this, "m_ReOpenCount", 0);
        _defineProperty(this, "sanitizeAvatarId", (role, avatarId)=>{
            const isProtectedAvatar = true; // protectedAvatarIdList.includes(parseInt(avatarId))
            const invalidAvatarId = isProtectedAvatar && role !== 'presenter' && role !== 'staff';
            return invalidAvatarId ? '0' : avatarId;
        });
    }
}
